export default __webpack_public_path__ + "static/media/logo-n-white.4b7057a2.svg";